import { Component, OnInit } from '@angular/core';
import { parse } from 'querystring';
import { CommonProjectDataService } from "../../_services/common-project-data.service";
import { Router } from '@angular/router';
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormArray,
  FormControl
} from "@angular/forms";

@Component({
  selector: 'app-add-product-cart',
  templateUrl: './add-product-cart.component.html',
  styleUrls: ['./add-product-cart.component.css']
})
export class AddProductCartComponent implements OnInit {
  public addProductCartForm: FormGroup;
  public storeProject: any = {};
  private activeProjIndex = 0;
  private activeProdIndex = 0;
  public prodData: any = {};
  public SelectProductData: any = [];
  selectedSize = [];
  public totalPrice = 0;
  private totalQty=0;
  selectedMockupImage:string;
  public totalCartProduct=0;

  constructor(private CommonProjectDataService: CommonProjectDataService,
    private formBuilder: FormBuilder,
    private router: Router
  ) { }

  ngOnInit() {
    this.addProductCartForm = this.formBuilder.group({
      size: [null, Validators.required],
      quantity: [null, Validators.required],
      notes: [null],
    });
    //this.storeProject = JSON.parse(JSON.stringify(this.CommonProjectDataService.getQuoteData()));
    this.storeProject=JSON.parse(localStorage.getItem("storeData"));
    this.activeProjIndex = this.CommonProjectDataService.getActiveProject();
    this.activeProdIndex = this.CommonProjectDataService.getActiveProductIndex();
    
    //this.activeProjIndex=parseInt(localStorage.getItem("projIndex"));
    //this.activeProdIndex=parseInt(localStorage.getItem("productIndex"));
    this.prodData = this.storeProject.projects_data[this.activeProjIndex].products[this.activeProdIndex];   
    //this.SelectProductData = this.CommonProjectDataService.getSelectProductData();
    this.SelectProductData = localStorage.getItem("SelectProductData")?JSON.parse(localStorage.getItem("SelectProductData")):[];
    let projectExist = this.SelectProductData.find(x => x.product[0].project_index == this.activeProjIndex);
    //this.totalPrice = this.CommonProjectDataService.getSubTotalPrice();
    this.totalCartProduct=localStorage.getItem("totalCartProduct")?parseInt(localStorage.getItem("totalCartProduct")):0

    this.totalPrice=localStorage.getItem("totalPrice")?Number(localStorage.getItem("totalPrice")):0
    //this.totalQty=this.CommonProjectDataService.getCartTotalQty();
    this.totalQty=localStorage.getItem("totalQty")?parseInt(localStorage.getItem("totalQty")):0
    if (typeof projectExist === 'undefined') {
      this.SelectProductData.push({
        'product': [{
          size: [],
          quantity: [],
          brand: this.prodData.productDetail.brand,
          name: this.prodData.productDetail.name,
          retail_price: this.prodData.retail_price,
          image: this.prodData.matrix[0].color.front_image,
          description: this.prodData.productDetail.description,
          SelectedProduct: this.activeProdIndex,
          project_index: this.activeProjIndex,
          matrix_index: 0,
          store_id: this.storeProject.store_id,
          order_id: this.storeProject.order_id,
          product_id: this.prodData.productDetail.product_id,
          color_id:this.prodData.matrix[0].color.color_id,
          shop_id:this.storeProject.shop_id,
          user_id:this.storeProject.user_id,
          product_title:this.prodData.product_title,
          turn_around_time_key:this.storeProject.turn_around_time_key,
          turn_around_times:this.storeProject.turn_around_times,
          notes: ""
        }
        ]
      })

    }  

  }

  isFieldValid(field: string) {
    return (
      !this.addProductCartForm.get(field).valid &&
      this.addProductCartForm.get(field).touched
    );
  }

  saveCartData(postData) {
    let totalLength = this.SelectProductData.length - 1;
    let currentIndex = this.SelectProductData.findIndex(x => x.product[0].project_index == this.activeProjIndex);
    let isSizeExist = this.SelectProductData[currentIndex].product[0].size.findIndex(x => x.size_id == postData.size.size_id);

    if (isSizeExist == -1) {
      this.SelectProductData[currentIndex].product[0].size.push(postData.size);
      this.SelectProductData[currentIndex].product[0].quantity.push(postData.quantity);
    }
    else {
      this.SelectProductData[currentIndex].product[0].quantity[isSizeExist] = parseInt(postData.quantity) + parseInt(this.SelectProductData[currentIndex].product[0].quantity[isSizeExist]);
    }
    this.SelectProductData[currentIndex].product[0].notes = postData.notes;
    this.totalPrice += this.prodData.retail_price * postData.quantity;
    this.totalQty +=Number(postData.quantity);
    //this.CommonProjectDataService.storeCartTotalQty(this.totalQty);
    //this.CommonProjectDataService.storeSubTotalPrice(this.totalPrice);
    localStorage.setItem("totalQty",this.totalQty.toString());
    localStorage.setItem("totalPrice",this.totalPrice.toString());
    localStorage.setItem("SelectProductData",JSON.stringify(this.SelectProductData));
    if (isSizeExist == -1) {
      this.totalCartProduct +=1;
      localStorage.setItem("totalCartProduct",this.totalCartProduct.toString());
    }
    
    //this.CommonProjectDataService.storeSelectProductData(this.SelectProductData);   
    this.router.navigate(["store/cart"]);

  }

  showMockupImage(imageUrl)
  {
    this.selectedMockupImage=imageUrl;
  }


}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-store-product/add-product-cart/add-product-cart.component.ts